module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-12 bg-lightest border-light card-height-1 d-flex flex-column radius-normal"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('div', {
    staticClass: "text-center darker font-weight-600 mt-4 fs-large"
  }, [_vm._v("\n            " + _vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dark text-center fs-small"
  }, [_vm._v("\n            " + _vm._s(_vm.subTitle) + "\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "text-center w-100 mb-5 mt-4"
  }, [_c('div', {
    staticClass: "fs-super-big dark font-weight-400 mt-1"
  }, [_vm._v(_vm._s(_vm.value1))]), _vm._v(" "), _c('div', {
    staticClass: "fs-larger",
    class: _vm.value2Class
  }, [_vm._v(_vm._s(_vm.value2))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ebc470"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/cardSimple.vue
// module id = 2559
// module chunks = 0